import { $qs, $qsa } from "../../../src/js/utils/querySelector";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function parallaxStats() {
    var parallaxStatParent = $qs('[data-target=parallax-stat-parent]');
    var stat1 = $qs('[data-target=parallax-stat-1]')
    var stat2 = $qs('[data-target=parallax-stat-2]')
    var stat3 = $qs('[data-target=parallax-stat-3]')
    var stat4 = $qs('[data-target=parallax-stat-4]')    

    var blurTitle = $qs('[data-target=js-blurry-title]');
    var statCover = $qs('[data-target=js-stat-cover]');
    var statCoverImages = $qs('[data-target=js-stat-cover-images]');


    
    if(parallaxStatParent && window.innerWidth > 767) {
        if(blurTitle) {
            ScrollTrigger.sort();


            var blurryTL = gsap.timeline({
                scrollTrigger: {
                    trigger: parallaxStatParent,
                    // pin: parallaxStatParent,
                    start: 'bottom bottom',  
                    scrub: true, 
                    end: "+=1500px",
                    delay: 3
                }
                
            })
        }
        
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: parallaxStatParent,
                start: "top center",            
                scrub: true,
                // markers: true                
            }
        })
        tl.to($qs('#image', stat1), {
            y: -100,
            ease: "power3.out"
        }, "<")  
        tl.to($qs('#stat', stat1), {
            y: -200,
            ease: "power3.out"
        }, "<")  
        tl.to($qs('#image', stat2), {
            y: -130,
            ease: "power3.out"
        }, "<")  
        tl.to($qs('#stat', stat2), {
            y: -170,
            ease: "power3.out"
        }, "<")  
        tl.to($qs('#image', stat3), {
            y: -200,
            ease: "power3.out"
        }, "<")  
        tl.to($qs('#stat', stat3), {
            y: -120,
            ease: "power3.out"
        }, "<")  
        tl.to($qs('#image', stat4), {
            y: -90,
            ease: "power3.out"
        }, "<")  
        tl.to($qs('#stat', stat4), {
            y: -250,
            ease: "power3.out"
        }, "<")  

        
        // only on prep site
        if(blurTitle) {
            // blurryTL.fromTo(blurTitle, {
            //     filter: "blur(0px)"
            // }, {
            //     filter: "blur(12px)"
            // })
            blurryTL.to(statCoverImages, {
                yPercent: -50,
                
            }, ">")
            blurryTL.to(parallaxStatParent, {
                clipPath: "inset(0 0 100%)"
            },"<")
            // blurryTL.to(statCover, {
            //     yPercent: -100
            // }, "<")

            blurryTL.to(statCover, {
                zIndex: 10
            }, ">")
        }
    }

}

export default parallaxStats